module.exports = __webpack_public_path__ + "static/media/14UNEP4.3022ee87.jpg";